export { DisplayCarousel, type DisplayCarouselProps } from './DisplayCarousel';
